import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

const flexCenter = `
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`
export const Form = styled.div`
    ${flexCenter}
    padding: 1.4rem 0;
    flex-grow: 1;
    width: 100%;
    justify-content: flex-end;
`

export const ContainerButton = styled.div`
    padding: 0 1.4rem 0 1.4rem;
    width: 100%;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`

export const OverviewContainer = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: column;
    width: 100%;
    padding: 0 1.4rem 0 1.4rem;
`
